import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/breadcrumb/breadcrumb.component.ts